module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_c09-dbc2af8ddd02941b2e0a4bb7335f9410.jpg";